import Image from 'next/image';
import Link from 'next/link';
import largeImage from '@/public/images/penzu-logo-white.png';
import smallImage from '@/public/images/penzu-icon-red.png';

export default function Logo(props: { size?: 'small' | 'large' } = {}) {
  const { size = 'large' } = props;
  return (
    <Link
      href="/"
      className="block text-white transition duration-150 ease-in-out relative top-1"
      aria-label="Penzu"
    >
      {size === 'large' ? LargeLogo() : SmallLogo()}
    </Link>
  );
}

function LargeLogo() {
  return (
    <Image
      src={largeImage}
      alt="Penzu"
      className="w-[114px] h-[33px]"
      width={114}
      height={33}
      priority
    />
  );
}

function SmallLogo() {
  return (
    <Image
      src={smallImage}
      alt="Penzu"
      className="w-[48px] h-[48px]"
      width={48}
      height={48}
      priority
    />
  );
}
